import Icon, { RightOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Flex, Radio } from 'antd';
import React, { useDeferredValue } from 'react';
import categoryIdToIconMapper from '~/components/shared/CategoryIcon/CategoryIcon';
import { api } from '~/services/api';

export default function CategorySuggestion({ changeCategory, title, selectedCategories }) {
  const deferredTitle = useDeferredValue(title);

  const { data } = useQuery({
    queryKey: ['categoriesSuggestion', deferredTitle],
    queryFn: () =>
      api.get(`/suggerer_categorie/?type=${deferredTitle}`).then((res) => {
        if (res.success) {
          return res.data.results.slice(0, 3);
        }
        if (typeof res.message?.error === 'string') {
          throw new Error(res.message.error);
        }
        throw new Error(res.message.error.message);
      }),
    enabled: !!deferredTitle,
  });

  if (!data || data.length === 0) {
    return null;
  }

  const currentCategory = selectedCategories && selectedCategories.length > 0 ? selectedCategories[selectedCategories.length - 1].id : null;
  const currentCategoryData = data.find((categorie) => categorie.id === currentCategory) ? currentCategory : null;

  return (
    <>
      <Flex vertical gap={16}>
        <Radio.Group
          value={currentCategoryData}
          onChange={(e) => {
            const value = e.target.value;
            const categorie = data.find((categorie) => categorie.id === value);
            changeCategory(
              categorie.ordered_parents.map((id, index) => ({
                id: id,
                value: categorie.parents_names[index],
              }))
            );
          }}
        >
          <Flex vertical gap={16}>
            {data.map((categorie) => {
              const parentCategoryId = categorie.ordered_parents.length > 0 ? categorie.ordered_parents[0] : null;
              const parents = categorie.parents_names.length > 2 ? categorie.parents_names.slice(1, -1) : [];
              const childCategoryName = categorie.parents_names.length > 0 ? categorie.parents_names[categorie.parents_names.length - 1] : '';

              return (
                <Flex key={categorie.id} gap={8} align='center'>
                  <Radio id={categorie.id} value={categorie.id} />
                  <label htmlFor={categorie.id} className='cursor-pointer'>
                    <Flex gap={8} align='center'>
                      <Icon className='category-icon' component={categoryIdToIconMapper(parentCategoryId)} />
                      {parents.map((parentName, index) => (
                        <React.Fragment key={index}>
                          <RightOutlined className='small-arrow' />
                          <p className='body1'>{parentName}</p>
                        </React.Fragment>
                      ))}
                      <RightOutlined className='small-arrow' />
                      <p className='body1'>{childCategoryName}</p>
                    </Flex>
                  </label>
                </Flex>
              );
            })}
          </Flex>
        </Radio.Group>
        <p className='body1 text-grey-medium'>Ou</p>
      </Flex>
    </>
  );
}
